function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import ContMyTables from '@/views/refactoring/ContMyTables.vue';
import ContMyTablesComponent from './components/ContMyTablesComponent.vue';
import ContMyDatasources from '@/views/refactoring/ContMyDatasources';
import ContMyDashboards from '@/views/refactoring/ContMyDashboards';
import ContMyDatasets from '@/views/refactoring/ContMyDatasets';
import ContMyReports from '@/views/refactoring/ContMyReports';
import ContMyReportsGds from '@/views/refactoring/ContMyReportsGDS';
import SearchBussinessTerm from '@/components/SearchBusinessTerm';
import ContMyBusinessTermsComponent from './components/ContMyBusinessTermsComponent.vue';
import ContMyDatasourcesComponent from './components/ContMyDatasourcesComponent.vue';
//import ContMyAccess from '@/views/ContMyAccess'
import ContMyAccessComponent from './components/ContMyAccessComponent.vue';
import BaseLoading from '@/components/BaseLoading';
import { tabsMixin } from '@/mixins/tabs_mixim';
import { resizeMixin } from '@/mixins/resize_mixin';
import ContMyDashboardsComponent from './components/ContMyDashboardsComponent.vue';
import ContMyDatasetsComponent from './components/ContMyDatasetsComponent.vue';
import ContMyDatasourcesGdsComponent from './components/ContMyDatasourcesGdsComponent.vue';
import ContMyReportsComponent from './components/ContMyReportsComponent.vue';
import ContMyReportsGdsComponent from './components/ContMyReportsGdsComponent.vue';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
import { ALL_TABLES_OPTION, envConfig, textsDefaul, TYPE_CHANGE_METADA } from '@/js/constants';
export default {
  name: 'MyObjectsPage',
  mixins: [tabsMixin, resizeMixin],
  components: {
    ContMyTables: ContMyTables,
    ContMyTablesComponent: ContMyTablesComponent,
    ContMyDatasources: ContMyDatasources,
    ContMyDashboards: ContMyDashboards,
    ContMyDatasets: ContMyDatasets,
    SearchBussinessTerm: SearchBussinessTerm,
    ContMyAccessComponent: ContMyAccessComponent,
    ContMyReports: ContMyReports,
    ContMyReportsGds: ContMyReportsGds,
    BaseLoading: BaseLoading,
    ContMyBusinessTermsComponent: ContMyBusinessTermsComponent,
    ContMyDatasourcesComponent: ContMyDatasourcesComponent,
    ContMyDashboardsComponent: ContMyDashboardsComponent,
    ContMyDatasetsComponent: ContMyDatasetsComponent,
    ContMyReportsComponent: ContMyReportsComponent,
    ContMyReportsGdsComponent: ContMyReportsGdsComponent,
    ContMyDatasourcesGdsComponent: ContMyDatasourcesGdsComponent,
    OrganizacionComponent: OrganizacionComponent
  },
  data: function data() {
    return {
      show_report: false,
      url_report: '',
      isLoadingIframe: true,
      is_maximun: false,
      typeSelected: 1,
      filter_enabled: false,
      // true,
      filter: {
        text_filter: '',
        choose_domain: null
      },
      list_source: [{
        value: 'bigquery',
        text: "Bigquery"
      }, {
        value: 'synapse',
        text: "Azure Synapse"
      }],
      source: 'bigquery'
    };
  },
  created: function created() {
    this.filter.choose_domain = "All";
    if (this.$route.params.tab) {
      this.typeSelected = Number.parseInt(this.$route.params.tab);
      this.onResetFilters();
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['isTableauActive', 'isPowerBIActive', 'isDataStudioActive', 'isSynapseActive'])), {}, {
    objectTypes: function objectTypes() {
      var options = [{
        value: 1,
        text: 'My Access'
      }, {
        value: 2,
        text: 'My Tables'
      }, {
        value: 3,
        text: 'My Business Terms'
      }];
      if (this.isTableauActive) {
        options.push({
          value: 4,
          text: 'My TBL Datasources'
        });
        options.push({
          value: 5,
          text: 'My TBL Dashboards'
        });
      }
      if (this.isPowerBIActive) {
        options.push({
          value: 6,
          text: 'My PBI Datasets'
        });
        options.push({
          value: 7,
          text: 'My PBI Reports'
        });
      }
      if (this.isDataStudioActive) {
        options.push({
          value: 8,
          text: 'My GDS Reports'
        });
        options.push({
          value: 9,
          text: 'My GDS Datasources'
        });
      }
      return options;
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) return 'col-md-9 col-sm-12';else return 'col-sm-12';
    },
    tab: function tab() {
      return {
        access: this.traductor('tabs.access'),
        tables: this.traductor('tabs.tables'),
        bterms: this.traductor('tabs.bterms'),
        tbl_datasources: this.traductor('tabs.tbl_datasources'),
        tbl_dashboards: this.traductor('tabs.tbl_dashboards'),
        pbi_datasets: this.traductor('tabs.pbi_datasets'),
        pbi_reports: this.traductor('tabs.pbi_reports'),
        gds_reports: this.traductor('tabs.gds_reports')
      };
    },
    object_types: function object_types() {
      var options = [{
        value: 1,
        text: this.traductor('tabs.access')
      }, {
        value: 2,
        text: this.traductor('tabs.tables')
      }, {
        value: 3,
        text: this.traductor('tabs.bterms')
      }].concat(_toConsumableArray(this.isTableauActive ? [{
        value: 4,
        text: this.traductor('tabs.tbl_datasources')
      }] : []), _toConsumableArray(this.isTableauActive ? [{
        value: 5,
        text: this.traductor('tabs.tbl_dashboards')
      }] : []), _toConsumableArray(this.isPowerBIActive ? [{
        value: 6,
        text: this.traductor('tabs.pbi_datasets')
      }] : []), _toConsumableArray(this.isPowerBIActive ? [{
        value: 7,
        text: this.traductor('tabs.pbi_reports')
      }] : []), _toConsumableArray(this.isDataStudioActive ? [{
        value: 8,
        text: this.traductor('tabs.gds_reports')
      }] : []), _toConsumableArray(this.isDataStudioActive ? [{
        value: 9,
        text: this.traductor('tabs.gds_datasources')
      }] : []));
      /*if (this.isTableauActive) {
        options.push({ value: 4, text: this.traductor('tabs.tbl_datasources') })
        options.push({ value: 5, text: this.traductor('tabs.tbl_dashboards') })
      }
      if (this.isPowerBIActive) {
        options.push({ value: 6, text: this.traductor('tabs.pbi_datasets') })
        options.push({ value: 7, text: this.traductor('tabs.pbi_reports') })
      }
      if (this.isDataStudioActive) {
        options.push({ value: 8, text: this.traductor('tabs.gds_reports') })
      }*/
      return options;
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.getTitleOwner(this.typeSelected - 1),
        disabled: true
      }];
    },
    processd_list_domains: function processd_list_domains() {
      var list_domains = [];
      list_domains = window.userInfo ? Object.values(window.userInfo.listOrgs) : [];
      list_domains.unshift(window.userInfo.domain);
      list_domains.unshift(ALL_TABLES_OPTION);
      return list_domains;
    }
  }),
  methods: {
    onMessage: function onMessage(item) {
      if (item == 1) {
        this.$store.commit("app/setToastMessage", {
          color: "primary",
          icon: "mdi-check-bold",
          title: "Success",
          subtitle: "Todo ok!"
        });
        this.$store.commit("app/setShowMessage", true);
      } else {
        this.$store.commit("app/setToastMessage", {
          color: "error",
          icon: "icon-decline",
          title: "Error",
          subtitle: "Ocurrio un error, intentelo en unos minutos!"
        });
        this.$store.commit("app/setShowMessage", true);
      }
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onCloseReport: function onCloseReport() {
      this.url_report = '';
      this.show_report = false;
      this.isLoadingIframe = true;
    },
    onShowReport: function onShowReport(url) {
      this.url_report = url;
      this.show_report = true;
      this.isLoadingIframe = true;
    },
    loadIframe: function loadIframe() {
      console.log('loaded');
      this.isLoadingIframe = false;
    },
    fullScreen: function fullScreen() {
      this.is_maximun = !this.is_maximun;
    },
    onSearch: function onSearch() {
      this.$refs["refSelected" + this.typeSelected].onSearch(this.filter);
    },
    onLimpiar: function onLimpiar() {
      this.onResetFilters();
      this.$refs["refSelected" + this.typeSelected].onCleanSearch();
    },
    onResetFilters: function onResetFilters() {
      this.filter.text_filter = "";
      if (this.typeSelected == 2) {
        this.filter.choose_domain = window.userInfo.domain;
      } else if (this.typeSelected == 3) {
        this.filter.choose_domain = window.userInfo.domain;
      } else if (this.typeSelected == 4) {
        this.filter.choose_domain = window.userInfo.domain;
      } else if (this.typeSelected == 5) {
        this.filter.choose_domain = window.userInfo.domain;
      } else if (this.typeSelected == 6) {
        this.filter.choose_domain = window.userInfo.domain;
      } else if (this.typeSelected == 7) {
        this.filter.choose_domain = window.userInfo.domain;
      } else if (this.typeSelected == 8) {
        this.filter.choose_domain = window.userInfo.domain;
      } else if (this.typeSelected == 9) {
        this.filter.choose_domain = window.userInfo.domain;
      } else {
        this.filter.choose_domain = "All";
      }
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onChangeSource: function onChangeSource() {
      console.log("source");
      this.$refs["refSelected" + this.typeSelected].reloadList({
        "source": this.source ? this.source : "bigquery"
      });
    },
    onChangeType: function onChangeType() {
      this.filter.text_filter = "";
      this.filter.choose_domain = "All";
      if (this.typeSelected == 2) {
        this.filter.choose_domain = window.userInfo.domain;
      } else if (this.typeSelected == 3) {
        this.filter.choose_domain = window.userInfo.domain;
      } else if (this.typeSelected == 4) {
        this.filter.choose_domain = window.userInfo.domain;
      } else if (this.typeSelected == 5) {
        this.filter.choose_domain = window.userInfo.domain;
      } else if (this.typeSelected == 6) {
        this.filter.choose_domain = window.userInfo.domain;
      } else if (this.typeSelected == 7) {
        this.filter.choose_domain = window.userInfo.domain;
      } else if (this.typeSelected == 8) {
        this.filter.choose_domain = window.userInfo.domain;
      } else if (this.typeSelected == 9) {
        this.filter.choose_domain = window.userInfo.domain;
      }
    }
  }
};